export default __webpack_public_path__ + "static/media/subjektet_zgjedhore.219e1b59.jpg";